<template>
  <ui-component-modal
    modalTitle=""
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="save"
    :showModal="showModal"
    :modalSize="'large'"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <table class="table is-fullwidth is-striped">
        <tbody>
          <tr>
            <td>Name</td>
            <td><input type="text" v-model="mBundle.Name" /></td>
          </tr>
          <tr>
            <td>Is addon</td>
            <td><input type="checkbox" v-model="mBundle.IsAddOn" /></td>
          </tr>
          <tr>
            <td>Functionalities</td>
            <td>
              <FunctionalityMenu
                @functioniltyUpdate="updateSelectedFunctionalities"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'

export default {
  components: {
    FunctionalityMenu: () =>
      import('@/components/Functionalities/FunctionalityMenu'),
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      channelId: Number(this.$route.params.channelId),
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mBundle: null,
    }
  },

  computed: {
    ...mapState('bundleStore', ['bundle']),
    ...mapState('functionalityStore', ['functionalities']),
  },

  created() {
    this.mBundle = JSON.parse(JSON.stringify(this.bundle))
    this.mBundle.Functionalities = this.bundle.Functionalities.map((f) => f.Id)

    if (this.functionalities.length === 0) {
      this.getAllFunctionalities()
    }
  },

  methods: {
    ...mapActions('bundleStore', ['editBundle']),
    ...mapActions('functionalityStore', ['getAllFunctionalities']),

    updateSelectedFunctionalities(functionalities) {
      this.mBundle.Functionalities = functionalities
    },

    save() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true

        self
          .editBundle(self.mBundle)
          .then((response) => {
            if (response.status === 200) {
              // Send message to display toast on screen
              EventBus.$emit('showToast', {
                type: 'info',
                message: 'Bundle updated!',
              })

              self.onClickCancel()
            }
          })
          .finally(() => {
            self.isSaving = false
          })
      }
    },
  },
}
</script>
